export const EPARGN_PRODUCT_SCR = 801;
export const EPARGN_PRODUCT_SCR_NAME = 'Assurance vie SCR';
export const EMPTY_OBJECT = {};
export const EMPTY_ARRAY = [];
export const IMAM_POLICIES = ['2000GRP0001653', '2000GRP0001654'];
export const NEC = 'NEC';
export const SHARED_DATA = {
  loginToggle: 'loginToggle',
};

export const LOCATION_HISTORY_SOURCE = {
  findAgent: 'findAgent',
  directoryOfDoctors: 'directoryOfDoctors',
};

export const SINISTER_DOCUMENT_TYPES = {
  ACCORD: 'ACCORD',
  CI: 'CI',
  CV: 'CV',
  DECOMPTE: 'DECOMPTE',
};
export const ADHESION_DOCUMENT_TYPES = {
  CA: 'CA',
};

export const MOROCCO = 'MA';

export const FIND_CHARGE_URL = 'https://findcharge.ma/map';
